import { Link } from "react-router-dom";
import { blogs } from "../../data/blogs";

const FeaturedBlogs = () => {
  const featured = blogs[0];

  return (
    <section className="py-12 bg-slate-50">
      <div className="container-custom">

        <div className="bg-white rounded-3xl overflow-hidden shadow-lg">

          <div className="grid lg:grid-cols-2">

            <img
              src={featured.image}
              alt={featured.title}
              className="w-full h-full object-cover"
            />

            <div className="p-10">

              <span className="inline-block bg-[#F59E0B] text-white px-4 py-2 rounded-full text-sm">
                Featured Post
              </span>

              <h2 className="text-4xl font-bold text-[#082B57] mt-6">
                {featured.title}
              </h2>

              <p className="text-gray-600 mt-6 leading-8">
                {featured.excerpt}
              </p>

              <Link
                to={`/blogs/${featured.slug}`}
                className="inline-block mt-8 bg-[#082B57] text-white px-8 py-4 rounded-xl"
              >
                Read Article
              </Link>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default FeaturedBlogs;